import {createReducer, on} from '@ngrx/store';
import {toggleGridView} from './layout.actions';
import {LayoutState} from '../layout.model';



export const layoutFeatureKey = 'collectionLayout';

export const initialState: LayoutState = {
  isGridView: true
};

export const layoutReducer = createReducer(
  initialState,
  on(toggleGridView, state => ({
    ...state,
    isGridView: !state.isGridView
  }))
);
